import { reduceNumHotProspects, useCampaignLeadResponseStats } from 'data/campaign-stats';
import React, { useMemo } from 'react';

import { Box, useTheme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import CampaignEngagementsTable from 'components/CampaignEngagementsTable/CampaignEngagementsTable';
import StatsEmailClicksIcon from 'components/CustomIcons/stats/StatsEmailClicksIcon';
import StatsEmailOpensIcon from 'components/CustomIcons/stats/StatsEmailOpensIcon';
import StatsPropertiesIcon from 'components/CustomIcons/stats/StatsPropertiesIcon';
import StatsQRCodeScansIcon from 'components/CustomIcons/stats/StatsQRCodeScansIcon';
import DashboardSection from 'components/DashboardSection/DashboardSection';
import StatCard from 'components/Stats/StatCard';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  noDataText: {
    marginTop: '60px',
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '24px',
    lineHeight: '36px',
    color: theme.palette.black.main,
  },
}));

export default () => {
  const classes = useStyles();
  const theme = useTheme();

  const { leadResponseStats } = useCampaignLeadResponseStats();

  const aggregatedStats = useMemo(() => {
    if (!leadResponseStats) return undefined;

    return {
      hotProspects: reduceNumHotProspects(leadResponseStats),
      qrCodeScans: leadResponseStats.AGENT_LANDING_OPEN.length,
      emailOpens: leadResponseStats.EMAIL_OPEN.length,
      emailClicks: leadResponseStats.EMAIL_CLICK.length,
    };
  }, [leadResponseStats]);

  const hasNoLeadResponses = useMemo(() => leadResponseStats && Object.values(leadResponseStats).every((arr) => Array.isArray(arr) && arr.length === 0), [leadResponseStats]);

  return (
    <div className={classes.root}>
      <DashboardSection
        sectionName="Your Lead Activity"
      />
      {hasNoLeadResponses ? (
        <Box display="flex" justifyContent="center" alignItems="center">
          <p className={classes.noDataText}>
            Once your campaign touches are delivered and we aggregate enough data, your lead activity will appear here!
          </p>
        </Box>
      )
        : (
          <>
            <Box sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              mt: 4,
            }}
            >
              <StatCard
                title="Hot Prospects 🔥"
                stat={aggregatedStats?.hotProspects}
                icon={<StatsPropertiesIcon />}
                boxSx={{ bgcolor: theme.palette.white.main }}
              />

              <StatCard
                title="QR Code Scans"
                stat={aggregatedStats?.qrCodeScans}
                icon={<StatsQRCodeScansIcon />}
                boxSx={{ bgcolor: theme.palette.white.main }}
              />

              <StatCard
                title="Email Opens"
                stat={aggregatedStats?.emailOpens}
                icon={<StatsEmailOpensIcon />}
                boxSx={{ bgcolor: theme.palette.white.main }}
              />

              <StatCard
                title="Email Clicks"
                stat={aggregatedStats?.emailClicks}
                icon={<StatsEmailClicksIcon />}
                boxSx={{ bgcolor: theme.palette.white.main }}
              />
            </Box>

            <Box>
              <CampaignEngagementsTable hotProspectsOnly={false} />
            </Box>
          </>
        )}
    </div>
  );
};
